import { Scenarios } from '@jfs/network'

const getBankNamesList = {
  default: [
    {
      url: /crm\/getIFSCCode/,
      method: 'POST',
      body: /"bankName":""/,
      response: {
        response: 'SUCCESS',
        bankName: ['ICICI BANK', 'HDFC Bank'],
      },
      delay: 500,
    },
    {
      url: /crm\/getIFSCCode/,
      method: 'POST',
      body: /"bankName":"ICICI Bank"/,
      response: {
        status: 'SUCCESS',
        cityName: ['Mumbai', 'Pune'],
      },
      delay: 500,
    },
    {
      url: /crm\/getIFSCCode/,
      method: 'POST',
      body: /"bankName":"ICICI Bank",cityName:"Mumbai"/,
      response: {
        response: 'SUCCESS',
        branchName: ['Thane Branch', 'Pune Branch'],
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /crm\/getIFSCCode/,
      method: 'POST',
      responseCode: 501,
      response: {
        response: 'FAILURE',
        error: { code: '33607', message: 'INVALID.' },
      },
      delay: 1000,
    },
  ],
} as Scenarios

export { getBankNamesList }
